import RfiAnalytics from './RfiAnalytics.component';

export default RfiAnalytics;